var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"percentage"},[_c('h2',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.percentage)+"%")])]),_c('canvas',{attrs:{"id":_vm.canvasId}})])}
var staticRenderFns = []

export { render, staticRenderFns }